<template>
  <div id="login" class="fx-aj-c" @click="confirmSta = false">
    <!-- 注册 -->
    <div class="signUpCard">
      <img src="@/assets/logo.png" class="logoImg" @click="$router.push('/login')"/>
      <div class="titleBar">
        <!--        <p>{{ $t("common.personal.register") }}</p>-->
        <!--        <span>{{ $t("common.slogan") }}</span>-->
      </div>
      <div class="inputBar tel-container">
        <div class="flex-center pointer flagareaC" style="word-break: initial">
          <CountrySelect @changeSelect="getSelectValue"></CountrySelect>
        </div>
        <el-input v-model="signUpInfo.phone" :placeholder="$t('sys.tip.input.phone')" @input="checkPhone"
                  type="number"/>
      </div>
      <div class="inputBar" style="position: relative">
        <el-input v-model="signUpInfo.password" :type="isTypePassword ? 'password' : 'text'"
                  :placeholder="$t('common.login.password')"
                  @blur="checkPassword"
                  :minLength="8" :maxLength="18"
                  @keydown.native="keydown($event)"/>
        <el-icon class="passwordIcon" @click="changeType" v-if="!isTypePassword">
          <View/>
        </el-icon>
        <el-icon class="passwordIcon" @click="changeType" v-if="isTypePassword">
          <Hide/>
        </el-icon>
      </div>
      <div style="width:420px;font-size: 13px;color: #aaaaaa;margin-top: 10px;margin-bottom: 10px">
        {{ i18n.global.t('common.password.text') }}
      </div>
      <div class="inputBar" style="margin-top: 0px;">
        <el-input v-model="signUpInfo.code" :placeholder="$t('sys.tip.input.sms.code')"
                  :maxLength="4"/>
      </div>
      <!--          验证-->
      <el-button :disabled="sendFlag" style="width: 100%;margin-top: 20px;" class="button" size="medium"
                 @click="verificationCode">{{ textInner }}
      </el-button>
      <div class="fx-j-c">
        <div class="confirmbar" @click="register" v-if="signUpInfo.phone && signUpInfo.password && signUpInfo.code">
          {{ $t("common.complete.gologin") }}
        </div>
        <div class="confirmbar_not" v-else>
          {{ $t("common.complete.gologin") }}
        </div>
      </div>
      <div class="loginbar">
        <span>{{ $t("common.label.hasaccount") }}，</span>
        <span class="edit" style="font-size: 14px;color: #0a84ff" @click="goSignIn">
          {{
            $t("common.gotologin")
          }}</span>
      </div>
    </div>
    <!-- 底部信息栏 -->
    <Footers></Footers>
  </div>
</template>
<script>

import flag from '@/assets/flag/index.js'
import {checkPhoneIsRegister, sendRegisterSms} from '../api/index';
import {ElMessage} from 'element-plus';
import CountrySelect from "@/components/CountrySelect/index.vue";
import Footers from '@/components/Footer'
import {i18n} from "../lang";
import {passwordReg} from "@/utils/statusParams";
import {loadTencentCaptchaScript} from "@/utils/tencentCaptcha";

export default {
  name: 'Register',
  components: {
    CountrySelect,
    Footers
  },
  data() {
    return {
      textInner: i18n.global.t('sys.click.re.code'),
      isShowText: false,
      flag,
      confirmSta: false,
      sendFlag: false,
      currentCountry: {
        countryEn: "China", country: "中国大陆", prefix: "86", icon: "CN.png", id: "43", zoneCode: "CN"
      },
      value: 86,
      isPhone: false,
      isPassword: true,
      isTypePassword: true,
      isInput: false,
      isCode: false,
      signUpInfo: {
        phone: '',
        password: '',
        code: '',
      },
      invitedCode: '',
      invitedProductId: '',
      codeBtnWord: '',
      waitTime: 61,
      getCodeBtnDisable: false,
      isLoading: false,
      searchData: {
        ticket: 'ff',
        randStr: 'f',
      },
      phoneCode: '',
      disabledBtn: false,
    };
  },
  computed: {
    i18n() {
      return i18n
    },
    isLangCN() {
      // return this._store('lang') == 'zh-CN'
      return true;
    }
  },
  mounted() {
    this.disabledBtn = false;
    try {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      this.invitedCode = q.invitedCode ? String(q.invitedCode) : ''
      this.invitedProductId = q.invitedProductId ? String(q.invitedProductId) : ''
    } catch (e) {
      this.invitedCode = ''
      this.invitedProductId = ''
    }
    // this.initSlider();
  },
  methods: {
    clickPassword() {
      this.isShowText = true;
    },
    getSelectValue(val) {
      this.currentCountry = val;
    },
    goSignIn() {
      this.$router.push('/login');
    },
    // 人机验证
    async verificationCode() {
      const captchaId = '196846099'
      const _this = this

      if (!_this.signUpInfo.phone) {
        ElMessage.error(i18n.global.t('forget.password.iphone'));
        return;
      }

      try {
        const TencentCaptcha = await loadTencentCaptchaScript()
        const captcha = new TencentCaptcha(captchaId, (res) => {
          if (res.ret === 0) {

            // 票据
            _this.searchData.ticket = res.ticket
            _this.searchData.randStr = res.randstr
            _this.disabledBtn = true

            sendRegisterSms({
              phone: _this.signUpInfo.phone,
              phoneCode: _this.currentCountry.prefix,
              type: 1
            }).then(result => {
              ElMessage.success(i18n.global.t('common.email.list.sendSuccess'))
              _this.waitTime--
              _this.textInner = _this.$t('displace.smscode.reacquire', {number: _this.waitTime})
              _this.sendFlag = true
              const timer = setInterval(() => {
                if (_this.waitTime > 1) {
                  _this.waitTime--
                  _this.textInner = _this.$t('displace.smscode.reacquire', {number: _this.waitTime})
                } else {
                  _this.sendFlag = false
                  clearInterval(timer)
                  _this.textInner = i18n.global.t('sys.click.re.code')
                  _this.waitTime = 61
                  // _this.initSlider()
                }
              }, 1000)
            })
          }
        })
        // 显示验证码
        captcha.show()
      } catch (error) {
        ElMessage.error(error?.message || '验证码加载失败，请稍后重试')
        return
      }
    },
    initSlider() {
      var wrapper = this.$refs.wrapper;
      var btn = this.$refs.btn;
      var bg = this.$refs.bg;
      var text = this.$refs.text;
      var left = null;
      const self = this;
      btn.onmousedown = function (event) {
        console.log(event.clientX);
        if (!self.signUpInfo.phone) {
          ElMessage.error(i18n.global.t('forget.password.iphone'));
          return;
        }
        var downX = event.clientX;      //触发事件时 鼠标相对于浏览器的x距离
        document.onmousemove = function (e) {
          var moveX = e.clientX;
          console.log(moveX);        //触发事件时 鼠标相对于浏览器的x距离

          left = moveX - downX;      //点击down移动move 滑动的距离

          if (left < 0) {
            left = 0
          }
          if (left > wrapper.offsetWidth - btn.offsetWidth) {      //还需要减去btn的宽度
            left = wrapper.offsetWidth - btn.offsetWidth;
          }
          btn.style.left = left + 'px';
          bg.style.width = left + 'px';

          if (left >= wrapper.offsetWidth - btn.offsetWidth) {
            console.log(left, wrapper.offsetWidth, btn.offsetWidth);
            //ajax请求 判断是否可以登录成功
            wrapper.style.color = 'white';
            btn.onmousedown = null;    //防止 btn再次被点击
            document.onmousemove = null;
            document.onmouseup = null;
            sendRegisterSms({
              phone: self.signUpInfo.phone, phoneCode: self.currentCountry.prefix, type: 1
            }).then(result => {
              ElMessage.success(i18n.global.t('common.email.list.sendSuccess'));
              self.waitTime--;
              text.innerText = self.$t('displace.smscode.reacquire', {number: self.waitTime})
              self.sendFlag = true;
              const timer = setInterval(() => {
                if (self.waitTime > 1) {
                  self.waitTime--
                  text.innerText = self.$t('displace.smscode.reacquire', {number: self.waitTime})
                } else {
                  self.sendFlag = false;
                  btn.style.left = 0;
                  bg.style.width = 0;
                  wrapper.style.color = 'black';
                  clearInterval(timer)
                  text.innerText = i18n.global.t('send.message.code')
                  self.waitTime = 61;
                  self.initSlider();
                }
              }, 1000)
            })
          }
        }
      }

      // btn.onmousedown    //不能只监听滑块上的鼠标抬起; 在整个文档上鼠标抬起体验更好
      document.onmouseup = function (event) {
        document.onmousemove = null;
        if (left < wrapper.offsetWidth - btn.offsetWidth) {
          btn.style.left = 0;
          bg.style.width = 0;
          wrapper.style.color = 'black';
        }
        console.log('鼠标抬起' + event.clientX)
        document.onmouseup = null;
      }
    },
    changeConfirmE(e) {
      this.confirmSta = e
    },
    selectFlag(obj) {
      this.currentCountry = obj
      console.log(this.currentCountry)
    },
    // 禁止输入空格
    keydown(e) {
      if (e.keyCode == 32) {
        e.returnValue = false
      }
    },
    phoneTimer() {

    },
    changeType() {
      this.isTypePassword = !this.isTypePassword
    },
    showInfo() {
    },
    checkPhone() {
      if (this.signUpInfo.phone) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    checkPassword(e) {
      if (passwordReg.test(this.signUpInfo.password)) {
        this.password = true;
      } else {
        this.isPassword = false;
        ElMessage.warning(this.$t('common.password.text'))
      }
    },
    async getRegisterSms() {
      // const result = await
      // console.log(result, '1110, 验证码');
    },
    conmfirmSignUp() {
      // if (!/^(?=.*[0-9])(?=.*[a-zA-Z]).{8,18}$/.test(this.signUpInfo.password)) {
      if (!passwordReg.test(this.signUpInfo.password)) {
        return this.$message.error(this.$t('sys.message.error.password'))
      }

      // this.$api.V2CheckPhoneIsRegister({ account: this.signUpInfo.phone, zoneCode: this.currentCountry.zoneCode, password: this.signUpInfo.password }).then(res => {
      // 	if (res.data == true) {
      // 		// 手机号已被注册
      // 		this.$message.error(this.$t('sys.message.error.phone.hassignup'), 1)
      // 	} else {
      // 	}
      // })
      this.sendSMS()
    },
    sendSMS() {
      this.phoneTimer()
      this.signUpInfo.code = ''
      this.isCode = false
      checkPhoneIsRegister({
        account: this.signUpInfo.phone,
        password: this.signUpInfo.password
      })
          .then(res => {
            this.$message.success(this.$t('sys.message.success.sendsmscode'), 1)
            this.isInput = true
          })
          .catch(err => {
            console.log('Has Error!!!')
          })
    },
    checkCode() {
      if (this.signUpInfo.code.length == 4) {
        this.isCode = true
      } else {
        this.isCode = false
      }
    },
    register() {
      if (this.isLoading) return
      this.isLoading = true
      const nextLoginDraft = {
        loginType: '0',
        account: String(this.signUpInfo.phone || ''),
        password: String(this.signUpInfo.password || ''),
        phoneCode: String(this.currentCountry.prefix || '')
      }
      const payload = {
        phone: this.signUpInfo.phone,
        password: this.signUpInfo.password,
        code: this.signUpInfo.code,
        phoneCode: this.currentCountry.prefix
      }
      if (this.invitedCode) payload.invitedCode = this.invitedCode
      if (this.invitedProductId) payload.invitedProductId = this.invitedProductId

      checkPhoneIsRegister(payload)
          .then((res) => {
            if (res.code !== 200) {
              ElMessage.error(res.message)
              return
            }
            ElMessage.success(res.message)
            // 重置
            this.signUpInfo = {
              phone: '',
              password: '',
              code: '',
            }
            this.currentCountry = {
              countryEn: "China", country: "中国大陆", prefix: "86", icon: "CN.png", id: "43", zoneCode: "CN"
            }
            try {
              sessionStorage.setItem('post_register_login_draft', JSON.stringify(nextLoginDraft))
            } catch (e) {
            }
            this.$router.push({path: '/login', query: {force: '1'}})
          })
          .catch(err => {
            this.signUpInfo.code = ''
            this.isCode = false
          })
          .finally(() => {
            this.isLoading = false
          })
    }
  }
}
</script>
<style lang="less" scoped>
.wrapper {
  position: relative;
  width: 380px;
  height: 34px;
  line-height: 34px;
  background-color: #f5f5f5;
  border: 1px solid var(--el-input-border-color, var(--el-border-color));
  // box-shadow: 0 0 0 1px var(--el-input-border-color,var(--el-border-color)) inset;
  margin: 20px auto 0;
  border-radius: 4px;

  .bg {
    position: absolute;
    height: 100%;
    width: 0;
    background: #7ac23c;
    z-index: 1;
  }

  .text {
    position: absolute;
    width: 100%;
    margin: 0;
    font-size: 14px;
    text-align: center;
    z-index: 2;
  }

  .btn {
    position: absolute;
    top: 0;
    width: 40px;
    height: 32px;
    z-index: 3;
    // border: 1px solid #ccc;
    background: #fff center no-repeat;
    /***btn背景图片***/
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
}


#login {
  height: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  color: #1890ff;
}

.el-input :deep(.el-input__wrapper) {
  background-color: white !important;
  padding: 0;

  .el-input__inner {
    padding: 0 11px;
  }
}

input {
  height: 50px;
}

.infoBar {
  margin-top: 10px;
  // width: 343px;
  letter-spacing: 1px;
  font-size: 14px;
}

.ant-input:hover {
  background-color: #f5f5f5;
}

.signUpCard {
  position: relative;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
  min-width: 440px;
  width: 440px;
  padding: 30px;

  .logoImg {
    position: absolute;
    width: 218px;
    height: 42px;
    left: 0;
    top: -50px;
  }
}

.confirmCard {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
  width: 420px;
  padding: 30px;
}

.passwordIcon {
  position: absolute;
  right: 20px;
  top: 19px;
}

// 注册页面
.titleBar {
  p {
    margin-bottom: 10px;
    font-size: 24px;

    font-weight: 600;
    color: #333333;
    line-height: 24px;
    padding: 0;
  }

  span {
    margin-top: 10px;
    font-size: 14px;

    color: #333333;
  }
}

.inputBar {
  position: relative;
  margin-top: 20px;
  height: 50px;
}

.confirmbar {
  cursor: pointer;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #d93737;
  color: white;
  border-radius: 25px;
  margin-top: 20px;
  font-size: 15px !important;
}

.confirmbar_not {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #f5f5f5;
  color: gray;
  border-radius: 25px;
  font-size: 15px !important;
  margin-top: 20px;
}

.loginbar {
  margin: 10px auto 0;
  text-align: center;
  font-size: 14px;

  .edit {
    color: #1890ff;
    cursor: pointer;
  }
}

.tel-container {
  display: flex;
  align-items: center;
}

:deep(.flag-list-box) {
  background: white !important;
}

// 底部版权信息等
.footerInfoBar {
  position: fixed;
  bottom: 60px;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mr-10 {
  margin-right: 10px;
}

.pointer {
  cursor: pointer;
}

.p-10 {
  padding: 10px;
}

.wrapClass {
  max-height: 70vh;
}

.flagareaC {
  font-size: 14px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flagC {
  font-size: 28px;
  margin-right: 5px;
}

:deep(.el-input__inner) {
  height: 52px !important;
  width: 100% !important;
  line-height: 52px !important;
}
</style>
